type ProjectCompanyLike = {
  companyName?: string | null;
  company_name?: string | null;
  client?: string | null;
};

const clean = (value: unknown): string => {
  return typeof value === 'string' ? value.trim() : '';
};

export const getProjectCompanyLabel = (
  project: ProjectCompanyLike | null | undefined,
  fallback = ''
): string => {
  if (!project) return fallback;
  return clean(project.companyName) || clean(project.company_name) || clean(project.client) || fallback;
};

export const getProjectSecondaryLabel = (
  project: ProjectCompanyLike | null | undefined
): string => {
  if (!project) return '';
  const company = clean(project.companyName) || clean(project.company_name);
  const client = clean(project.client);
  if (company && client && company !== client) {
    return `${company} · ${client}`;
  }
  return company || client;
};
